// DEALS-7A-2B-1-BOARD-VIEW/v1 — a CSS-only import (no exports): its sole job is adding this
// instance's enabled modules' own source to Tailwind's content-detection scan, which
// `@b2b/platform-ui`'s own stylesheet cannot portably do for a cross-package tree. See that
// file's own doc comment for the measured reason and why the fix lives here instead.
//
// CORRECTION (view-switch-placement fix) — MUST be imported BEFORE `@b2b/platform-ui/boot`, not
// after. Real, measured defect: with this import written AFTER `boot`'s, ES module import
// hoisting still runs `boot`'s own transitive `index.css` (this codebase's ONE real Tailwind
// entry point, chunk A) first and this file's own independent `@import "tailwindcss"` (chunk B)
// second — and for any utility class BOTH chunks happen to generate (any class literally used in
// BOTH `packages/platform-ui/src` and a Module's own source — `flex-col`, here, from
// `TableToolbar.tsx`'s `secondaryAction` layout AND `DealsBoardPage.tsx`'s column containers),
// chunk B's plain rule lands textually after chunk A's correctly-ordered `sm:`-prefixed variant of
// the SAME class, silently overriding it site-wide (not module-scoped) — measured directly: with
// the old order, `TableToolbar`'s own `sm:flex-row` computed to `flex-direction: column` even at
// 1440px, because `.flex-col{}` (re-emitted by chunk B) appeared AFTER `@media(width>=40rem){
// .sm\:flex-row{}}` in the built stylesheet. `TableToolbar`'s `secondaryAction` slot had no real
// consumer before this unit (grep confirms: `DealsListPage.tsx`/`DealsBoardPage.tsx` are the only
// two call sites in the whole codebase), so this ordering defect was real but entirely latent
// until now. Importing this file FIRST makes chunk B's utilities the ones chunk A's correctly-
// ordered variants land after instead — re-measured after this reorder: `sm:flex-row` computes to
// `flex-direction: row` at 1440px, Panel's own top-left corner unaffected (unrelated to this
// ordering question). Disclosed, not a general fix: a THIRD module enabling a class combination
// that collides in the opposite direction would need the same kind of investigation this comment
// documents — the underlying two-Tailwind-entry-point architecture (see that file's own doc
// comment) is what makes this class of bug possible at all, not this particular ordering.
import './moduleTailwindSources.css';
import { boot } from '@b2b/platform-ui/boot';
import { registerModulesUi } from './registerModulesUi.js';

/**
 * This instance's own Vite entry — PER-INSTANCE-BUILD/v1 (frontend-
 * composition-root design, Unit B). `instances/smoke/index.html`'s
 * `<script type="module">` tag loads THIS file, not
 * `packages/platform-ui/src/main.tsx` (which remains the entry for
 * `packages/platform-ui`'s own shared, unparameterised build — unchanged by
 * this unit, still what `App.build.test.ts` exercises).
 *
 * `boot` is imported from `@b2b/platform-ui`'s narrow `./boot` subpath
 * (UI-SURFACE/v1, Unit A) — the reviewed cross-package exception
 * `check-public-imports.mjs`'s allowlist already carries; nothing here
 * widens that guard. Calling it WITH `registerModules` is the one thing
 * `packages/platform-ui/src/main.tsx`'s own zero-argument call site does
 * not do — see `registerModulesUi.tsx`'s own doc comment for what this
 * instance actually registers today (nothing yet, correctly).
 */
void boot({ registerModules: registerModulesUi });
